import React from 'react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { publicCompany, accents } from '../../data/site';
export function PublicCompany() {
  return <section className="relative overflow-hidden bg-white py-24 lg:py-32" data-id="element-214" data-mp="3qragzk094pc9">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-215" data-mp="3qp7kch4lfxyk">
        <SectionHeading eyebrow="Public Company Experience" title="Governance held to a listed-company standard." description="Experience supporting publicly traded issuers across two exchanges — where disclosure discipline, board process, and capital markets execution are non-negotiable." data-id="element-216" data-mp="3lro81mrghv99" />

        <div className="mt-16 grid gap-px overflow-hidden border border-navy/10 bg-navy/10 md:grid-cols-2 lg:grid-cols-3" data-id="element-217" data-mp="37uslcria85aq">
          {publicCompany.map((item, index) => {
          const accent = accents[index % accents.length];
          return <Reveal key={item.title} delay={index % 3 * 0.06} className="group relative overflow-hidden bg-mist p-9 transition-colors duration-500 hover:bg-white" data-id="element-218" data-mp="1139xrbs0vl8q" data-mpi={index}>
                <span className="absolute right-6 top-6 font-display text-5xl font-light opacity-15 transition-opacity duration-500 group-hover:opacity-40" style={{
              color: accent
            }} aria-hidden="true" data-id="element-219" data-mp="39oqndfxvpt9j">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="relative font-display text-xl font-normal text-navy" data-id="element-220" data-mp="3tbwq7mhr04v8">{item.title}</h3>
                <p className="relative mt-3 max-w-xs text-sm leading-relaxed text-charcoal/70" data-id="element-221" data-mp="3ena9bgch351w">
                  {item.detail}
                </p>
                <span className="absolute inset-y-0 left-0 w-1 origin-top scale-y-0 transition-transform duration-500 group-hover:scale-y-100" style={{
              backgroundColor: accent
            }} aria-hidden="true" data-id="element-222" data-mp="3jjijefbtc827" />
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}